import Intro from "../../components/Intro/Intro";
import Services from "../../components/Services/Services";
import Experience from "../../components/Experience/Experience";
import Portfolio from "../../components/Portfolio/Portfolio";
import Testimonial from "../../components/Testimonials/Testimonial";
import Contact from "../../components/Contact/Contact";
import PageSeo from "../../components/seo/PageSeo";
import JsonLd from "../../components/seo/JsonLd";
import { homeSeo, organizationLd } from "../../seo/seoConfig";

function Home() {
  return (
    <>
      <PageSeo
        title={homeSeo.title}
        description={homeSeo.description}
        path={homeSeo.path}
      />
      <JsonLd data={organizationLd} />
      <Intro />
      <Services />
      <Experience />
      <Portfolio />
      <Testimonial />
      <Contact />
    </>
  );
}

export default Home;
